export const UNAVAILABLE_ERROR_PAGE = '/erreur/indisponible'
